import React, { ReactNode } from 'react'
import Drawer from './Drawer'
interface ReportDrawerProps {
    open: boolean;
    onClose: () => void;
    children: ReactNode;
    header: ReactNode;
}
const ReportDrawer: React.FC<ReportDrawerProps> = ({ open, onClose, children, header }) => {
    return (
        <Drawer header={header}
            open={open}
            close={onClose}
            position='left'
            className='pl-20 sm:w-[550px]'
        >
            <div>{children}</div>
        </Drawer>
    )
}

export default ReportDrawer